<template>
  <v-card flat :loading="loading" class="mt-5">
    <div class="chart-title">User Equity</div>
    <div class="chart-menu">
      <div v-bind:class="'submenu_userequity'">
        <div class="underline"></div>
        <div class="menuitem" @click="ul(0)">
          <span class="menutext">1 month</span>
        </div>
        <div class="menuitem" @click="ul(1)">
          <span class="menutext">2 months</span>
        </div>
        <div class="menuitem" @click="ul(2)">
          <span class="menutext">6 months</span>
        </div>
        <div class="menuitem" @click="ul(3)">
          <span class="menutext">12 months</span>
        </div>
        <div class="menuitem" @click="ul(4)">
          <span class="menutext">All</span>
        </div>

        <div class="menuitem mr-4">
          <modalsSettings type="userequty" />
        </div>
      </div>
    </div>
    <div class="mx-4 mb-4">
      <UserEquity :data="items" />
    </div>
  </v-card>
</template>



<script>
import { mapGetters } from "vuex";
import axios from "axios";
import UserEquity from "@/components/bigcharts/equity.vue";
export default {
  components: { UserEquity },
  data() {
    return {
      selectedIndex: 4,
      indexmap: [1, 2, 6, 12, 0],
      loading: false,
      items: [],
      tempName: this.$route.params.name
    };
  },
  watch: {
    "$route.params.name"(val) {
      this.tempName = val;
      if (!val) {
        this.tempName = this.username;
      }
      //this.ul(this.selectedIndex);
      this.getData();
    }
  },
  mounted() {
    if (!this.$route.params.name) {
      this.tempName = this.username;
    }
    this.ul(this.selectedIndex);
    this.getData();
  },
  computed: {
    ...mapGetters(["timezone", "username"])
  },
  methods: {
    getData() {
      //this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/request/results/", {
          method: "userequity",
          period: this.selectedIndex,
          user: this.tempName
        })
        .then(response => {
          this.items = response.data;
          //this.loading = false;
        });
    },
    ul(newSelection) {
      this.selectedIndex = newSelection;

      this.getData();

      var menuitem = document.querySelectorAll(".submenu_userequity .menuitem");
      var menutext = document.querySelectorAll(
        ".submenu_userequity .menuitem .menutext"
      );

      for (var i = 0; i < menutext.length; i++) {
        menutext[i].style.color = null;
      }
      menutext[this.selectedIndex].style.color = "#FFFFFF";
      var width = menutext[this.selectedIndex].offsetWidth;
      var x = menuitem[this.selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(
        ".submenu_userequity .underline"
      );
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }
  }
};
</script>

<style scoped>
.menuitem {
  font-weight: bold;
  font-size: 12px;
  color: #808f9c;
  display: inline-block;
  z-index: 10;
  text-align: left;
  cursor: pointer;
  margin-right: 20px;
}
</style>